import { render, staticRenderFns } from "./template.html?vue&type=template&id=7a15550a&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "../IButton/style.scss?vue&type=style&index=0&id=7a15550a&lang=scss&scoped=true&"
import style1 from "./style.scss?vue&type=style&index=1&id=7a15550a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15550a",
  null
  
)

export default component.exports